import eventBus from '@tools/event-bus';
import { FAVORITE_PROPOSAL_EVENT } from '@molecules/constants';
import { trans } from '@elements/translation';

interface FavoriteEvent {
    detail: {
        offerHashId: string,
        isActive: boolean,
        favorite: boolean,
    };
}

let locked: boolean = false;

export default function (button: HTMLButtonElement): void {
  const buttonIcon = button.querySelector('.offer-favorite-icon') as HTMLSpanElement;

  if (!buttonIcon) {
    return;
  }

  const { hashId } = button.dataset as { hashId: string };
  let isActive = buttonIcon.classList.contains('active');

  eventBus.addEventListener(FAVORITE_PROPOSAL_EVENT.OFFER_FAVORITE_TOGGLE_CALLBACK, (event: FavoriteEvent) => {
    const data = event.detail;

    if (data?.offerHashId !== hashId) {
      locked = false;
      return;
    }

    buttonIcon.classList.toggle('active', data.isActive);
    button.classList.toggle('active', data.isActive);

    const buttonText = button.querySelector('.offer-details__action__text') as HTMLSpanElement | null;
    if (!buttonText) {
      return;
    }

    isActive = data.favorite;

    buttonText.innerText = isActive ? trans('offer.remove_favorite') : trans('offer.add_favorite');

    locked = false;
  });

  button.addEventListener('click', (event: PointerEvent) => {
    event.preventDefault();
    if (locked) {
      return;
    }

    locked = true;

    const urlParams = new URLSearchParams(document.location.search);

    const selectedOffers: string[] = urlParams.get('selected_offers')?.split('|') ?? [];
    const teamSizeList: string[] = urlParams.get('team-size-list')?.split('|') ?? [];

    const offerTeamSizes = selectedOffers.map((offerHashId, index) => ({
      hashId: offerHashId,
      teamSize: teamSizeList[index] ? Number(teamSizeList[index]) : null,
    })) ?? [ { hashId, teamSize: null } ];

    eventBus.dispatchEvent(new CustomEvent(FAVORITE_PROPOSAL_EVENT.OFFER_FAVORITE_TOGGLE, {
      detail: {
        isActive: !isActive,
        offerHashId: hashId,
        origin: 'offer',
        offerTeamSizes,
        teamSize: urlParams.get('team-size'),
      },
    }));
  });

  button.setAttribute('data-ready', ('true'));
}
